import React, { useEffect, useState } from "react";
import emptyIconProfile from '../../images/emptyIconProfile.svg';
import styled from "styled-components";
import { getLastChatDate } from "../../utils/DateTimeHandler";
import usePortalService from "../../services/PortalService";
import useRole from "../../hooks/useRole";
import { UserRole } from "../../Enums/UserRole";
import { UnreadBadge } from './UnreadBadge';

const Dialogs = styled.div`
    display: flex;
    gap: 12px;
    padding: 0 16px;
    cursor: pointer;
    align-items: center;
    min-width: 0;

    &:hover {
        background-color: rgba(221, 239, 253, 1);
    }
`
const ChatSpoiler = styled.p`
    text-overflow: ellipsis;
    white-space: nowrap; 
    overflow: hidden;
    font-size: 14px;
    margin-top: 4px;
    flex: 1;
    min-width: 0;
    max-width: 80%;
`
export const Avatar = styled.img`
    width: 50px;
    height: 50px;
    border: 1px solid rgba(209, 214, 220, 1);
    border-radius: 8px;

    @media (max-width: 640px) {
        width: 42px;    
        height: 42px;
    }
`

const ChatInfoContainer = styled.div`
    flex: 1;
    width: 100%;
    padding: 20px 8px 20px 0px; 
    border-bottom: 1px solid rgba(209, 214, 220, 1);
    min-width: 0;
`

type DialogsListProps = {
    dateTime: string,
    interlocutorName: string,
    messageText: string,
    onClickDialog: (chatId: number, interlocutorId: number) => void,
    chatId: number,
    unreadCount: number,
    interlocutorId: number,
    avatarId?: string
}

export const DialogsList = ({dateTime, interlocutorName, messageText, onClickDialog, chatId, unreadCount, interlocutorId, avatarId} : DialogsListProps) => {
    const {getAvatar, getCompanyImage} = usePortalService();
    const {role} = useRole();
    const [avatar, setAvatar] = useState(emptyIconProfile);

    useEffect(() => {
        if (role === UserRole.Manager) {
            if (avatarId) {
                getAvatar(avatarId)  
                .then(result => {
                    setAvatar(result)
                })
            } else {
                setAvatar(emptyIconProfile)
            }
        }
        else {
            if (avatarId) {
                getCompanyImage(avatarId)  
                .then(result => {
                    setAvatar(result)
                })
            } else {
                setAvatar(emptyIconProfile)
            }
        }
    }, [avatarId]);

    return (
        <Dialogs onClick={() => onClickDialog(chatId, interlocutorId)}>
            <Avatar src={avatar}/>
            <ChatInfoContainer>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <h3 style={{fontSize: '16px'}}>{interlocutorName}</h3>
                    <span className="caption-small" style={{textTransform: "uppercase"}}>{getLastChatDate(dateTime)}</span>
                </div>
                {/* <span className="caption-small">{'Название организации'}</span> */}
                <div style={{display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'space-between', minWidth: 0}}>
                    <ChatSpoiler>{messageText}</ChatSpoiler>
                    <UnreadBadge 
                        count={unreadCount} 
                        overflow={99}
                    />
                </div>
            </ChatInfoContainer>
        </Dialogs>
    )
}